<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('INDEX.amz_sku_label_material_information') || '辅料信息'"
      :visible="visible"
      direction="rtl"
      :size="1000"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <div class="d-flex align-items-center" v-if="visible">
          <div>
            {{
              $l('INDEX.amz_sku_label_basic_information_materials') ||
                '物料基本信息'
            }}
          </div>
          <el-button
            class="ml-2"
            plain
            type="primary"
            size="mini"
            @click="chooseMaterialVisible = true"
            >{{
              $l('INDEX.product_dialog_btn_choose') || '从物料库选择'
            }}</el-button
          >
        </div>
        <MaterialInfoDescriptions
          class="mt-2"
          :data="formData"
          :disabled="true"
          @refresh="getData"
        ></MaterialInfoDescriptions>

        <el-form
          class="mt-2"
          v-if="amzSkuMaterialGroup === 'packaging'"
          ref="form"
          :model="formData"
          label-width="120px"
          label-position="top"
          size="mini"
          :rules="rules"
          :disabled="disabled"
          :validate-on-rule-change="false"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('INDEX.evg_sku_label_materialRange') || '使用范围'"
                prop="materialRange"
              >
                <dict-select
                  v-model="formData.materialRange"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'amzMaterialRange' }"
                  :placeholder="
                    $l('INDEX.evg_sku_placeholder_materialRange') ||
                      '请选择使用范围'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div
          v-if="
            amzSkuMaterialGroup === 'sewing' || formData.materialRange == 'A'
          "
          class="choose-fabric__wrapper mt-1"
        >
          <SpecMaterialTable
            :amzSkuCode="amzSkuCode"
            :disabled="disabled"
            :amzSkuMaterialCode="amzSkuMaterialCode"
            ref="materialInfo"
          ></SpecMaterialTable>
        </div>

        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            style="width:100px"
            @click="save()"
            v-if="!disabled"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
    <chooseMaterialDrawer
      ref="chooseMaterialDrawer"
      :title="$l('INDEX.material_choose_title') || '添加物料信息'"
      :visible.sync="chooseMaterialVisible"
      :productLine="'ABSHome'"
      :amzSkuMaterialGroup="amzSkuMaterialGroup"
      type="radio"
      @confirm="onMaterialConfirm"
      @addMaterial="addMaterialVisible = true"
    />
    <EditMaterial
      v-if="addMaterialVisible"
      :title="$l('INDEX.material_add_title') || '新增物料信息'"
      :visible.sync="addMaterialVisible"
      :productLine="'ABSHome'"
      :amzSkuMaterialGroup="amzSkuMaterialGroup"
      type="radio"
      @close="reloadList"
    />
    <CloseDialog :backDialogVisible.sync="backDialogVisible" @close="close" />
  </div>
</template>
<script>
import SpecMaterialTable from '../spec-material-table'
import EditLoading from '@/mixins/edit-loading'
import MaterialInfoDescriptions from '../material-info-descriptions'
import chooseMaterialDrawer from '.././choose-material/drawer.vue'
import EditMaterial from '../edit-material/drawer.vue'
import CloseDialog from '../close-dialog/index.vue'
import validate from '@/libs/util.validate'

export default {
  components: {
    SpecMaterialTable,
    MaterialInfoDescriptions,
    chooseMaterialDrawer,
    EditMaterial,
    CloseDialog,
  },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    amzSkuCode: { type: String, default: '' },
    amzSkuMaterialCode: { type: String, default: '' },
    amzSkuMaterialGroup: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      fabricList: [],
      formData: {
        baseQty: 1,
        materialRange: 'B',
      },
      chooseMaterialVisible: false,
      addMaterialVisible: false,
      backDialogVisible: false,
      rules: {
        materialRange: [
          {
            required: true,
            message: this.$l('INDEX.rules_materialRange') || '请选择使用范围',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    isEmpty() {
      return !this.fabricList.length
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.formData.materialRange =
        this.amzSkuMaterialGroup === 'sewing' ? 'A' : 'B'
      if (!this.amzSkuMaterialCode && !this.formData.amzSkuMaterialCode) return
      this.$api
        .ecomAmzSkuMaterialDetailApi({
          amzSkuMaterialCode:
            this.amzSkuMaterialCode || this.formData.amzSkuMaterialCode,
        })
        .then((res) => {
          this.formData = res.body
          if (this.amzSkuMaterialGroup === 'packaging') {
            setTimeout(() => {
              this.$refs.form.clearValidate('materialRange')
            }, 0)
          }
        })
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    reloadList() {
      this.$refs.chooseMaterialDrawer.reloadList()
    },

    async save() {
      if (!this.amzSkuMaterialCode && !this.formData.amzSkuMaterialCode) {
        this.$message.warning('请选择物料信息')
        return
      }
      let specMaterialList = []
      if (this.amzSkuMaterialGroup === 'packaging') {
        const result = await validate.formValidate([this.$refs.form])
        if (!result) return
      }
      if (
        this.amzSkuMaterialGroup === 'sewing' ||
        this.formData.materialRange == 'A'
      ) {
        specMaterialList = this.$refs.materialInfo.getCheckboxRecords() || []
      }
      if (
        this.amzSkuMaterialGroup === 'packaging' &&
        this.formData.materialRange == 'A' &&
        specMaterialList.length == 0
      ) {
        this.$message.warning('请勾选具体产品规格')
        return
      }

      this.loadingOpen()
      const params = {
        ...this.formData,
        amzSkuCode: this.amzSkuCode,
        specMaterialList,
      }
      const res = await this.$api
        .ecomAmzSkuMaterialSaveApi({
          ...params,
          amzSkuMaterialGroup: this.amzSkuMaterialGroup,
        })
        .catch(() => null)

      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })
      this.close()
    },

    handleClose() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    async onMaterialConfirm(data) {
      if (!data) return
      let materialRange = ''
      if (!this.formData.amzSkuMaterialCode) {
        materialRange = this.amzSkuMaterialGroup === 'sewing' ? 'A' : 'B'
      }
      this.loadingOpen()
      const params = {
        ...this.formData,
        amzSkuCode: this.amzSkuCode,
        materialCode: data.materialCode,
        materialRange: materialRange || this.formData.materialRange,
      }
      const res = await this.$api
        .ecomAmzSkuMaterialSaveApi({
          ...params,
          amzSkuMaterialGroup: this.amzSkuMaterialGroup,
        })
        .catch(() => null)

      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }

      this.$api
        .ecomAmzSkuMaterialDetailApi({
          amzSkuMaterialCode: body,
        })
        .then((res) => {
          const { materialRange } = this.formData
          this.formData = res.body
          this.formData.materialRange = materialRange
        })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}

.el-dialog__header {
  background-color: none;
}
</style>
